export default "__VITE_ASSET__c4162735__"